import React from "react";
import { Box, Container, Typography, Chip, useTheme } from "@mui/material";

// eslint-disable-next-line no-unused-vars
import { motion } from "framer-motion";

import Stats from "./Stats";
import MissionAndVision from "./MissionAndVision";
import WhyAdin from "./WhyAdin";
import OurValues from "./OurValues";
import Milestones from "./Milestones";
import Partners from "./Partners";
import Team from "./Team";
import SEOHelmet from "../../../Components/SeoHelmet";

export default function AboutUs() {
  const theme = useTheme();

  const sections = [
    { _id: 1, component: <Stats />, delay: 0.1 },
    { _id: 2, component: <MissionAndVision />, delay: 0.2 },
    { _id: 3, component: <WhyAdin />, delay: 0.1 },
    { _id: 4, component: <OurValues />, delay: 0.15 },
    { _id: 5, component: <Milestones />, delay: 0.1 },
    // { _id: 6, component: <Partners />, delay: 0.2 },
    { _id: 7, component: <Team />, delay: 0.15 },
  ];

  const sectionItems = sections.map((section) => (
    <motion.div
      key={section._id}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: section.delay }}
      viewport={{ once: true, amount: 0.2 }}
    >
      {section.component}
    </motion.div>
  ));
  return (
    <>
      <SEOHelmet
        title="درباره آدین زون | معرفی جامع‌ترین پلتفرم ورزشی"
        description="با آدین زون بیشتر آشنا شوید. هدف ما ایجاد ارتباطی هوشمند، سریع و آسان بین ورزشکاران، مربیان حرفه‌ای و مدیران باشگاه‌های ورزشی است."
        keywords="درباره آدین زون, تماس با آدین زون, معرفی پلتفرم ورزشی, استارتاپ ورزشی, پشتیبانی آدین زون"
        author="AdinZone"
      />
      <Box
        sx={{
          py: { xs: 6, md: 8 },
          bgcolor: "background.default",
        }}
      >
        <Container maxWidth="xl">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0 }}
            viewport={{ once: true, amount: 0.2 }}
          >
            <Box sx={{ textAlign: "center", mb: 8 }}>
              <Chip
                label="درباره ما"
                sx={{
                  bgcolor: `${theme.palette.primary.main}15`,
                  color: theme.palette.primary.main,
                  mb: 2,
                  fontWeight: 600,
                  px: 2,
                  py: 1.5,
                  fontSize: "0.85rem",
                }}
              />
              <Typography
                sx={{
                  fontWeight: 800,
                  fontSize: { xs: "1.5rem", md: "2rem" },
                  background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main}, #FF6B6B)`,
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  color: "transparent",
                  mb: 2,
                }}
              >
                با ما آشنا شوید
              </Typography>
              <Typography
                sx={{
                  color: "text.secondary",
                  fontSize: "0.9rem",
                  lineHeight: 1.8,
                  maxWidth: 700,
                  mx: "auto",
                  whiteSpace: "pre-wrap",
                  textAlign: "justify",
                }}
              >
                آدین‌زون یک مرجع جامع و تخصصی در حوزه ورزش است که با هدف معرفی
                مربیان، باشگاه‌ها و کسب‌وکارهای ورزشی در سراسر ایران راه‌اندازی
                شده است.
                <br />
                ما یک خانواده ورزشی هستیم که تلاش می‌کنیم به نیازمندی‌های جامعه
                ورزش پاسخ بدهیم؛ چه ورزشکارانی که به دنبال مربی و باشگاه مناسب
                هستند و چه مربیان و مدیرانی که به دنبال معرفی و جذب شاگردهای
                جدیدند.
                <br />
                📌 در آدین‌زون، هر مربی و باشگاه یک پروفایل اختصاصی دارد؛
                پروفایلی که مانند یک کارت ویزیت دیجیتال عمل می‌کند و شامل
                اطلاعات کامل، تصاویر حرفه‌ای، راه‌های ارتباطی و حتی تخفیف‌های
                ویژه برای مخاطبان است.
                <br />
                🎯 رسالت ما این است که پلی باشیم بین ورزشکاران و
                مربیان/باشگاه‌ها؛ جایی که اعتماد، همکاری و تخصص در کنار هم قرار
                می‌گیرد.
                <br />
                🌐 آدین‌زون فقط یک وب‌سایت نیست؛ یک جامعه ورزشی آنلاین است که هر
                روز در حال رشد است و تلاش می‌کند مسیر حرفه‌ای‌تر و آسان‌تری برای
                ورزش در ایران بسازد.
              </Typography>
            </Box>
          </motion.div>

          {/* same animated Section */}
          {sectionItems}
        </Container>
      </Box>
    </>
  );
}
